export default __webpack_public_path__ + "static/media/snack-bio-avatar-placeholder.fee465fb.png";